import { useSelector, useDispatch } from "react-redux";
import { fetchCliniciansByPracticeId } from "../../redux/clinic/clinicSlice";
import { useCallback } from "react";
import { RootState } from '../../redux';
import { AppDispatch } from '../../redux';

const useFetchClinicianByPractice = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { practiceClinicians, isLoading, practiceCliniciansCounts, practiceCliniciansPagination } = useSelector((state: RootState) => state.clinics);


  const fetchClinicianData = useCallback(async (
    practiceId: string,
    options?: {
      isActive?: boolean;
      page?: number;
      limit?: number;
      search?: string;
      specialty?: string;
      location?: string | string[];
      sortBy?: string;
    }
  ) => {
    try {
      if (practiceId) {
        await dispatch(fetchCliniciansByPracticeId({
          practiceId,
          isActive: options?.isActive,
          page: options?.page,
          limit: options?.limit,
          search: options?.search,
          specialty: options?.specialty,
          location: options?.location,
          sortBy: options?.sortBy
        })).unwrap();
      }
    } catch (error) {
      console.error('Failed to fetch clinicians by practice:', error);
    }
  }, [dispatch]);
    

  return { 
    practiceClinicians, 
    isLoading, 
    practiceCliniciansCounts, 
    practiceCliniciansPagination, 
    fetchClinicianData 
  };
};

export default useFetchClinicianByPractice;